import { render, staticRenderFns } from "./MergeDealerData.vue?vue&type=template&id=6b9b426e&scoped=true"
import script from "./MergeDealerData.vue?vue&type=script&lang=js"
export * from "./MergeDealerData.vue?vue&type=script&lang=js"
import style0 from "./MergeDealerData.vue?vue&type=style&index=0&id=6b9b426e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9b426e",
  null
  
)

export default component.exports